export enum FolderPermissions {
  Edit = 'PERMISSIONS_EDIT',
  View = 'PERMISSIONS_VIEW',
  Owner = 'PERMISSIONS_OWNER'
}

export type FrontEndFolderPermissions = 'owner' | 'can edit' | 'can view';
